/**
 * @generated SignedSource<<9a47bc7b78610bc32f5dd139700ed4b4>>
 * @relayHash aed7d9e402fa783a164042491bbedf28
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9b6ff8d1b59d07779e9e239870041ef5d155c63c4284ce2073bb37d344790a79

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphStoreDeleteProjectHasRelatedWorkWithProjectInput = {
  relationships: ReadonlyArray<GraphStoreDeleteProjectHasRelatedWorkWithProjectRelationshipInput>;
  synchronousWrite?: boolean | null | undefined;
};
export type GraphStoreDeleteProjectHasRelatedWorkWithProjectRelationshipInput = {
  from: string;
  to: string;
};
export type useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation$variables = {
  input?: GraphStoreDeleteProjectHasRelatedWorkWithProjectInput | null | undefined;
};
export type useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation$data = {
  readonly graphStore: {
    readonly deleteProjectHasRelatedWorkWithProject: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation = {
  response: useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation$data;
  variables: useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreDeleteProjectHasRelatedWorkWithProjectPayload",
            "kind": "LinkedField",
            "name": "deleteProjectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation",
    "selections": [
      {
        "concreteType": "GraphStoreMutation",
        "kind": "LinkedField",
        "name": "graphStore",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "GraphStoreDeleteProjectHasRelatedWorkWithProjectPayload",
            "kind": "LinkedField",
            "name": "deleteProjectHasRelatedWorkWithProject",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "id"
                          }
                        ],
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9b6ff8d1b59d07779e9e239870041ef5d155c63c4284ce2073bb37d344790a79",
    "metadata": {},
    "name": "useDisconnectProjectProjectHasRelatedWorkWithProjectDeleteMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "28ed51a7a4985efd66b750dbadac2ab1";

export default node;
